import * as D from '../../../utils/dbmodel';

export default {
    namespaced: true,
    state: {
        domainnameSelectOptions: [],  //部门下拉选项列表
        list: [], //table中的list显示数据
        pagination: {
            
        }, //分页相关的信息
        record: {}, //根据id查询的数据详情信息
    },

    getters: {
        getDomainnameSelectOptions(state) {
            return state.domainnameSelectOptions
        }
    },

    mutations: {
        save(state, action) {
            // console.log(action, "commit")
            // state = { ...state, ...action.payload }   //这么写不行，必须要遍历挨个重新赋值
            // state.domainnameSelectOptions = action.payload.domainnameSelectOptions
            for (var key in action.payload) {
                state[key] = action.payload[key]
            }
            // console.log(state, " yo ?") //跟console.log({ ...state, ...action.payload }) 的值是不一样的, 所以不能直接用展开运算符
        }
    },

    actions: {
        //查询系统列表信息
        selectSys(context, payload) {
            payload.type = 'system/querysys'
            return D.select({
                ...payload
            })
        },
        addSys(context, payload) {
            payload.type = 'system/addsys'
            return D.add({
                ...payload
            })
        },
        editSys(context, payload) {
            payload.type = 'system/editsys'
            return D.edit({
                ...payload
            })
        },
        deleteSys(context, payload) {
            payload.type = 'system/deletesys'
            return D.del({
                ...payload
            }).then(response => {
                context.dispatch('selectSys')
                return response
            })
        },
        //查询App列表信息
        selectApp(context, payload) {
            payload.type = 'system/queryapp'
            return D.select({
                ...payload
            })
        },
        addApp(context, payload) {
            payload.type = 'system/addapp'
            return D.add({
                ...payload
            })
        },
        editApp(context, payload) {
            payload.type = 'system/editapp'
            return D.edit({
                ...payload
            })
        },
        deleteApp(context, payload) {
            payload.type = 'system/deleteapp'
            return D.del({
                ...payload
            }).then(response => {
                context.dispatch('selectSys')
                return response
            })
        },

        //查询File列表信息
        selectFile(context, payload) {
            payload.type = 'system/queryfile'
            return D.select({
                ...payload
            })
        },
        addFile(context, payload) {
            payload.type = 'system/addfile'
            return D.add({
                ...payload
            })
        },
        editFile(context, payload) {
            payload.type = 'system/editfile'
            return D.edit({
                ...payload
            })
        },
        deleteFile(context, payload) {
            payload.type = 'system/deletefile'
            return D.del({
                ...payload
            }).then(response => {
                context.dispatch('selectSys')
                return response
            })
        },
      
    }
}